import api from './index';

const TEMPLATES_API = '/role-management/users-templates/';

// Cache for templates (10 minutes)
const CACHE_KEY = 'email_templates';
const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

const templatesAPI = {
  // Get all templates
  getAll: async () => {
    try {
      // Check cache first
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        const { data, timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < CACHE_DURATION) {
          return { ...data, cached: true };
        }
      }

      const response = await api.get(TEMPLATES_API);

      // Cache the results
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({
        data: response.data,
        timestamp: Date.now()
      }));

      return response.data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      throw error;
    }
  },

  // Get single template
  getById: async (id) => {
    try {
      const response = await api.get(`${TEMPLATES_API}${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching template ${id}:`, error);
      throw error;
    }
  },

  // Create new template
  create: async (data) => {
    try {
      const response = await api.post(TEMPLATES_API, data);

      // Invalidate cache
      sessionStorage.removeItem(CACHE_KEY);
      sessionStorage.removeItem('email_templates_cache');
      sessionStorage.removeItem('email_templates_cache_time');

      return response.data;
    } catch (error) {
      console.error('Error creating template:', error);
      throw error;
    }
  },

  // Update template
  update: async (id, data) => {
    try {
      const response = await api.put(`${TEMPLATES_API}${id}/`, data);

      // Invalidate cache
      sessionStorage.removeItem(CACHE_KEY);
      sessionStorage.removeItem('email_templates_cache');
      sessionStorage.removeItem('email_templates_cache_time');

      return response.data;
    } catch (error) {
      console.error(`Error updating template ${id}:`, error);
      throw error;
    }
  },

  // Delete template
  delete: async (id) => {
    try {
      const response = await api.delete(`${TEMPLATES_API}${id}/`);

      // Invalidate cache
      sessionStorage.removeItem(CACHE_KEY);
      sessionStorage.removeItem('email_templates_cache');
      sessionStorage.removeItem('email_templates_cache_time');

      return response.data;
    } catch (error) {
      console.error(`Error deleting template ${id}:`, error);
      throw error;
    }
  },

  // Clear cache manually
  clearCache: () => {
    sessionStorage.removeItem(CACHE_KEY);
    sessionStorage.removeItem('email_templates_cache');
    sessionStorage.removeItem('email_templates_cache_time');
  }
};

export default templatesAPI;

